import * as React from 'react'
import { CSSProperties } from 'react'
import { appBarOptions } from '../appBar'
import { MainMenuComponent } from "../mainMenu"
import { DefaultPageComponent } from 'fwork.react.apptemplate/src/components/defaultPage'


export const DefaultPageComp = (props: {
  children?: React.ReactNode,
  style?: CSSProperties,
}) => {
  return <DefaultPageComponent
    style={props.style}

    appBarOptions={appBarOptions()}

    leftDrawerOptions={{
      content: <MainMenuComponent />,
    }}

    leftAnchorOptions={{
      content: <MainMenuComponent styledDrawer />
    }}

    mainAnchorOptions={{
      content: <div style={{
        height: '100%',
        boxSizing: 'border-box',
      }}>
        {props.children}
      </div>

    }}
  />
}